module.exports = __webpack_public_path__ + "static/media/cod_burger2-dt-fr.5258f7a9.jpg";